import React from 'react';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-medium-image-zoom';
import { getUploadedImagePath } from '@nutastic/nutastic-react-app';
import Masonry from 'react-masonry-css';
import { gridBreakpoints } from '../utils/constants';
import PropTypes from 'prop-types';

const Gallery = ({ images }) => {
    const masonryBreakpoints = {
        default: 4,
        [gridBreakpoints.sm]: 2,
        [gridBreakpoints.md]: 2,
        [gridBreakpoints.lg]: 4
    };

    const renderedImages = images.map(({ image, name }, i) => {
        return <Fade bottom key={i}><Zoom>
            <img src={ getUploadedImagePath(image)} alt={name}/>
        </Zoom></Fade>;
    });

    return <Masonry breakpointCols={ masonryBreakpoints } className="gallery" columnClassName="gallery__column">
        { renderedImages }
    </Masonry>;
};

Gallery.propTypes = {
    images: PropTypes.array.isRequired
};
export default Gallery;
